const accessHub = require('./access_hub.png')

export { accessHub }